export default __webpack_public_path__ + "static/media/text-field-text-area.b82ad88f.svg";